import type { LayoutLoad } from './$types';
			import type { CategoryData } from '$lib/metadataTypes/MetaTypes';
			
			export const load: LayoutLoad = async ({ parent }): Promise<CategoryData> => {
				const { site } = await parent(); // parent() = SiteData
				return {
					site,
					category: {
							title: "Freon Examples — Explore Real DSL Implementations",
description: "Browse a collection of example domain-specific languages (DSLs) built with the Freon Language Workbench, showcasing different design approaches, metamodels, and projectional editors.",
tags: [ "examples", "DSLs", "Freon", "language workbench", "metamodel", "projectional editing", "code generation", "web editor"] 
					}
				};
			};